<template>
    <div class="chat-contacts">
        <div class="chat-contacts__content">
            <div class="chat-contacts__name">
                <span>{{ contact.firstName }} {{ contact.lastName }}</span>
            </div>
            <p v-if="contact.company" class="chat-contacts-item_company">
                <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="iconFillColor" d="M7.19.814a1.332 1.332 0 011.62 0l5.671 4.335c.722.552.335 1.704-.572 1.708H2.09C1.185 6.853.797 5.701 1.52 5.15L7.19.814zM8 4.857a.857.857 0 100-1.714.857.857 0 000 1.714zM2.857 8v3.429h1.714V8H2.857zM5.714 8v3.429H7.43V8H5.714zM8.571 8v3.429h1.715V8H8.57zM11.429 8v3.429h1.714V8h-1.714zM1.143 14c0-.789.64-1.429 1.429-1.429h10.857c.788 0 1.428.64 1.428 1.429v.286a.572.572 0 01-.571.571H1.714a.572.572 0 01-.571-.571V14z" />
                </svg>
                <span>{{ contact.company }}</span>
            </p>
            <p v-if="contact.position" class="chat-contacts-item_position">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="iconFillColor" fill-rule="evenodd" clip-rule="evenodd" d="M1.28574 13.8572C1.28574 13.8572 0.142883 13.8572 0.142883 12.7143C0.142883 11.5715 1.28574 8.14288 7.00003 8.14288C12.7143 8.14288 13.8572 11.5715 13.8572 12.7143C13.8572 13.8572 12.7143 13.8572 12.7143 13.8572H1.28574ZM7.00003 7.00003C7.90934 7.00003 8.78141 6.6388 9.42439 5.99582C10.0674 5.35284 10.4286 4.48077 10.4286 3.57146C10.4286 2.66214 10.0674 1.79007 9.42439 1.14709C8.78141 0.504107 7.90934 0.142883 7.00003 0.142883C6.09071 0.142883 5.21864 0.504107 4.57566 1.14709C3.93268 1.79007 3.57146 2.66214 3.57146 3.57146C3.57146 4.48077 3.93268 5.35284 4.57566 5.99582C5.21864 6.6388 6.09071 7.00003 7.00003 7.00003Z"/>
                </svg>
                <span>{{ contact.position }}</span>
            </p>
            <p v-if="contact.phoneNumber" class="chat-contacts-item_phoneNumber">
                <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="iconFillColor" d="M6.764 9.173a9.053 9.053 0 003.29 2.13l1.675-1.334a.297.297 0 01.338 0l3.11 2.004a.89.89 0 01.147 1.414l-1.457 1.44a1.777 1.777 0 01-1.614.475 15.595 15.595 0 01-7.622-4 15.018 15.018 0 01-4.12-7.48A1.68 1.68 0 011 2.244L2.511.787a.889.889 0 011.387.142L5.968 4a.28.28 0 010 .333l-1.364 1.64a8.778 8.778 0 002.16 3.2z"/>
                </svg>
                <span>{{ contact.phoneNumber }}</span>
            </p>
            <p v-if="contact.email" class="chat-contacts-item_email">
                <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="iconFillColor" d="M16 5.373V12.5a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 010 12.5V5.373l7.746 4.558a.5.5 0 00.508 0L16 5.373zM13.5 2a2.5 2.5 0 012.485 2.223L8 8.92.015 4.223A2.5 2.5 0 012.5 2h11z"/>
                </svg>
                <span>{{ contact.email }}</span>
            </p>
        </div>
        <div v-if="!isMy && needFooter" class="chat-contacts__actions">
            <button @click="downloadVCardFile(contact)" class="button is-green is-middle"> {{ $t('common.save') }} </button>
            <button class="message-btn button is-middle is-white" @click="$emit('sendContacts')">{{ $t('common.send own contacts') }}</button>
        </div>
    </div>
</template>

<script>

import { VCardGenerator } from "../../../../../common/VCardGenerator";
import Vue from 'vue'

export default Vue.extend({
    name: "",
    components: {},
    props: {
        contact: {
            type: Object,
            required: true,
        },
        isMy: {
            type: Boolean,
            required: true
        },
        needFooter: {
            type: Boolean,
            required: false,
            default: true
        },
        theme: {
            type: String,
            required: false,
            default: 'dark'
        }
    },
    methods: {
        downloadVCardFile(data) {
            return VCardGenerator.getUrlOrDowndload({
                version: "3.0",
                n: `${data.lastName};${data.firstName};;`,
                fn: `${data.lastName} ${data.firstName}`,
                org: data.company ? data.company : '',
                title: data.position ? data.position : '',
                tel: [
                    ...data.phoneNumber ? [{value: data.phoneNumber, type: "work"}] : []
                ],
                email: [
                    ...data.email ? [{ value: data.email, type: "internet" }] : []
                ]
            }, `${data.lastName} ${data.firstName}`, true);
        }
    },
    computed: {
        iconFillColor() {
            return this.theme === "light" && !this.isMy ? "#828282" : "#ffffff";
        }
    }
});

</script>